import { render, staticRenderFns } from "./DropdownNotification.vue?vue&type=template&id=295ca632"
import script from "./DropdownNotification.vue?vue&type=script&lang=js"
export * from "./DropdownNotification.vue?vue&type=script&lang=js"
import style0 from "./DropdownNotification.vue?vue&type=style&index=0&id=295ca632&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports